module.exports = __webpack_public_path__ + "img/18-4 Ready to Go and Stay Connected.b1ad6066.png";